import { Action } from '../actions/kahlInfoActions';
import { KahlInfo } from './types';

const initialState: KahlInfo = {
  kahlMessageId: null,
  kahlMessageDefaultType: null,
};

export default (state: KahlInfo = initialState, action: Action): KahlInfo => {
  switch (action.type) {
    case 'ADD_KAHL_MESSAGE':
      return {
        ...state,
        kahlMessageId: action.kahlMessageId,
        kahlMessageDefaultType: action.kahlMessageDefaultType
      };
    default:
      return state;
  }
};
